import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TablerIconsModule } from 'angular-tabler-icons';

/**
 * Re-exports the tabler icon component for the components that still import an
 * NgModule instead of the standalone directive.
 *
 * It deliberately does NOT call `TablerIconsModule.pick(...)`: `pick()` provides
 * OPTIONS_TOKEN with `multi: true`, and the icon set is already registered once
 * in `app.config.ts`. A second registration doubled `#options`, and
 * angular-tabler-icons merges every registered set with `Object.assign` on
 * **each** rendered icon — so picking twice literally doubled the CPU cost of
 * every `<i-tabler>` on every page.
 */
@NgModule({
  declarations: [],
  imports: [
    TablerIconsModule,
    CommonModule
  ],
  exports: [TablerIconsModule]
})
export class IconModule { }
